import request from '@/utils/request'

export function loginpost(data) {
  return request({
    url:'/api/cms/member/login',
    method:'post',
    data:{
      usname:data.usname,
      passwd:data.passwd,
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/home/home.js